<template>
  <div class="request_form_main_column">
    <div v-if="!viewSuccess" class="request-intro-tablet">
      <h2 class="request_form_header">Request Samples</h2>
      <p class='sub_heading'>Your swatches should arrive in 5-10 business days</p>
    </div>
    <figure class="sample_request_modal">
      <section v-if="!viewSuccess" class="sample_form_column">
        <form method="post" accept-charset="utf-8" enctype="multipart/form-data" id="materialSampleRequest-form" class="materialSampleRequest-form">
          <div class="quote-intro-mobile">
            <h2 class="request_form_header">Request Samples</h2>
            <p class="sub_heading">Your swatches should arrive in 5-10 business days</p>
          </div>
          <sample-request-form
            ref="sampleRequestForm"
            :selections="selections"
            @formLoaded="setFormLoaded"
            @isSubmitting="setIsSubmitting"
          />
          <div class="quote-actions">
            <button
              :disabled="submitDisabled"
              type="submit"
              @click.prevent="submit()"
              class="primary"
            >
              Request Samples
            </button>
          </div>
        </form>
      </section>
      <section v-if="viewSuccess" class="configurator-quote success">
        <img src="/assets/images/theme/icon_checksuccess.svg" alt="Success">
        <h2>Thank You!</h2>
        <p class="intro_subtext">A LightArt representative will reach out with shipping information shortly. Feel free to <a href="/contact">contact</a> us directly if you need an immediate response.</p>
        <button @click="complete()" type="button">Back to LightArt</button>
      </section>
      <div v-if="!viewSuccess" class="selected-samples">
        <h2 class="samples-header">Selected Swatches</h2>
        <div class="grid">
          <figure v-for="selection in selections" :key="selection.id" class="selected_sample">
            <img
              :alt="selection.title"
              :asset_id="selection.id"
              :src="selection.image_src || selection.image"
              :sizes="sizes"
              :srcset="selection.srcset"
              @click="handleSampleClick"
            />
            <div class="checkbox_container">
              <input
                :asset_id="selection.id"
                @click="handleSampleClick"
                :checked="selection.checked"
                type="checkbox"
                :ref="`modal_checkbox_${selection.id}`"
                :id="`modal_checkbox_${selection.id}`"
              />
              <label
                :asset_id="selection.id"
                :for="`modal_checkbox_${selection.id}`"
                @click="handleSampleClick"
              />
            </div>
            <h2 class="sku">{{ selection.sku.length > 10 ? selection.sku.substring(0, 10) + '...' : selection.sku }}</h2>
          </figure>
        </div>
      </div>
    </figure>
  </div>
</template>

<script>
import SampleRequestForm from '../SampleRequestForm';
import EventBus from '../../event_bus';

export default {
  props: {
    selections: Array,
    close: Function,
    updateSelections: Function,
  },
  data: function() {
    return {
      viewSuccess: false,
      formLoaded: false,
      isSubmitting: false,
      sizes: "(max-width: 34em) 84.926vw, (max-width: 46.875em) 85.067vw, (max-width: 61.9375em) 25.732vw, (max-width: 68.75em) 25.727vw, (max-width: 91.25em) 26.385vw, (max-width: 95.625em) 26.41vw, 404px",
    }
  },
  components: {
    SampleRequestForm,
  },
  mounted() {
    EventBus.$on('successfulSampleSubmission', () => this.viewSuccess = true);
  },
  computed: {
    currentUrl() {
      return window.location.href;
    },
    submitDisabled() {
      return !this.formLoaded || !this.samplesChecked || this.isSubmitting;
    },
    samplesChecked() {
      return this.selections.some((sample) => sample.checked);
    },
  },
  methods: {
    complete() {
      this.viewSuccess = false;
      this.close();
      this.$emit('completed');
    },
    setFormLoaded() {
      this.formLoaded = true;
    },
    setIsSubmitting(bool) {
      this.isSubmitting = bool;
    },
    handleSampleClick(event) {
      EventBus.$emit("sampleClicked", event, this.$refs);
      const {
        target: {
          attributes
        }
      } = event;

      const clickedSampleId = parseInt(attributes['asset_id'].value);
      this.updateSelections(clickedSampleId);
    },
    submit() {
     this.$refs.sampleRequestForm.submit();
    }
  }
}
</script>
